const errorHandler = async function(
  response,
  isItFile = false,
  isResponse = true,
) {
  if (!response.ok) {
    if (response.status === 400) throw Error('Niepoprawne żądanie')
    const error = await response.json()
    throw Error(error.ResponseStatus.Message)
  }
  if (!isResponse) return await response
  if (!isItFile) return await response.json()
  else return await response.blob()
}

const compare = function(val1, val2, nullAsString) {
  if (nullAsString) {
    if (!val1 && !val2) return true
    return val1 === val2
  }
  return val1 === val2
}

const controlHasError = function(
  errors,
  controlName,
  controlValue,
  nullAsString,
) {
  return (
    errors &&
    errors.some(data => {
      return controlValue
        ? data.NazwaPola === controlName &&
            compare(data.Wartosc, controlValue, nullAsString)
        : data.NazwaPola === controlName
    })
  )
}

export { errorHandler, controlHasError }
